import React from 'react'
import { Typography, ButtonPrimaryTextOnly } from '@creditas-ui/react'
import { useCardFeed } from 'homepage/application/useCardFeed.hook'
import { useInspectionLink } from 'shared/application/hooks/useInspectionLink'
import { InspectionLink } from 'shared/ui/InspectionLink'
import { DocumentsRequiredDetails } from '../../DocumentsRequiredDetails/DocumentsRequiredDetails'
import { CardContentFeed } from '../CardContentFeed'
import { CardHeaderResume } from '../CardHeaderResume'
import { CardResumeFeedStyle, FeedDescription } from './CardResumeFeed.styles'

const CardResumeFeed = ({ lead, documentsRequired }) => {
  const {
    currentStep,
    totalSteps,
    iconFeed,
    lastUpdate,
    showLinkInspection,
    lastFeedItem,
    sendDocumentButton,
    showDocumentsRequiredSubtitle,
  } = useCardFeed(lead)

  const useInspection = useInspectionLink(lead.id)

  return (
    <CardResumeFeedStyle {...lead}>
      <CardHeaderResume
        lastUpdate={lastUpdate}
        currentStep={currentStep}
        totalSteps={totalSteps}
      />
      <CardContentFeed icon={iconFeed}>
        <Typography color="neutral.90" component="h2" variant="bodyMdBold">
          {lastFeedItem?.title}
        </Typography>

        {showDocumentsRequiredSubtitle ? (
          <DocumentsRequiredDetails documentsRequired={documentsRequired} />
        ) : (
          <FeedDescription
            color="neutral.90"
            component="p"
            variant="bodySmLight"
            dangerouslySetInnerHTML={{
              __html: lastFeedItem?.subtitle,
            }}
          />
        )}
        {lastFeedItem?.rejectionDescription && (
          <FeedDescription
            color="neutral.90"
            component="p"
            variant="bodySmLight"
            dangerouslySetInnerHTML={{
              __html: lastFeedItem?.rejectionDescription,
            }}
          />
        )}
        {showLinkInspection && (
          <InspectionLink type="button" idProposal={lead?.id} />
        )}
        {sendDocumentButton.enabled && (
          <ButtonPrimaryTextOnly
            size="small"
            mt="24px"
            onClick={sendDocumentButton.handleClick}
            data-testid="send-documents-button"
          >
            Enviar documentos
          </ButtonPrimaryTextOnly>
        )}
      </CardContentFeed>
    </CardResumeFeedStyle>
  )
}

export { CardResumeFeed }
